import React from 'react'
import { useTranslation } from 'react-i18next'

export function RegistryErrorNotification() {
  const { t } = useTranslation()
  return <div className="registry-error-notification">{t('registration.registry_error')}</div>
}
